// NGRX
import { routerReducer, RouterReducerState } from '@ngrx/router-store';
import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { storeFreeze } from 'ngrx-store-freeze';

import { environment } from '../../../environments/environment';
import { listReducer } from '../../store/reducers/list.reducer';
import { ListState } from '../../store/models/list-state.model';

// tslint:disable-next-line:no-empty-interface
export interface AppState {
  router: RouterReducerState;
  list: ListState;
}

export const reducers: ActionReducerMap<AppState> = {
  router: routerReducer,
  list: listReducer
};

export const metaReducers: Array<MetaReducer<AppState>> = !environment.production ? [storeFreeze] : [];
